<div class="row">
  <div class="column">
    <app-rental-property-info [property]="property"></app-rental-property-info>
  </div>
  <div class="column">
    <div class="spacer"></div>
  </div>
</div>
